import { CommentViewController } from "./CommentViewController";
import { COMMENTS_ALLOWED_TYPE } from "./const/const";
var CommentExternalController = function (_a) {
    var entityId = _a.entityId, _b = _a.allowedType, allowedType = _b === void 0 ? COMMENTS_ALLOWED_TYPE.team : _b;
    return (React.createElement(CommentViewController, { postEntityId: entityId, entityType: allowedType }));
};
export default CommentExternalController;
//# sourceMappingURL=CommentExternalController.js.mapimport { CommentViewController } from "./CommentViewController";
import { COMMENTS_ALLOWED_TYPE } from "./const/const";
var CommentExternalController = function (_a) {
    var entityId = _a.entityId, _b = _a.allowedType, allowedType = _b === void 0 ? COMMENTS_ALLOWED_TYPE.team : _b;
    return (React.createElement(CommentViewController, { postEntityId: entityId, entityType: allowedType }));
};
export default CommentExternalController;
//# sourceMappingURL=CommentExternalController.js.map